<a
  [routerLink]="isLoading() ? null : tile().reportUrl"
  [queryParams]="tile().queryParams"
  [attr.data-automation]="tile().dataAutomation"
  class="tile btn dashboard-tile ziro-card btn-border"
  [ngClass]="{
    disabled: isLoading(),
    'btn-outline-default': !tile().status,
    'btn-outline-success': tile().status === TileStatus.GOOD,
    'btn-outline-warning': tile().status === TileStatus.WARNING,
    'btn-outline-info': tile().status === TileStatus.NEUTRAL,
    'btn-outline-danger': tile().status === TileStatus.CRITICAL,
  }"
>
  <div class="text-center">
    @if (isLoading()) {
      <div class="dashboard-tile__spinner-container">
        <i class="{{ ziroIcons.SAVING }} fa-3x"></i>
      </div>
    }
    @if (!isLoading()) {
      <h1 class="dashboard-tile__title">{{ tile().value }}</h1>
    }

    <span class="dashboard-tile__message">
      <p>
        {{ tile().message | translate: { count: tile().value } }}
      </p>
    </span>
  </div>
</a>
